'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { useMarket } from '@//providers/MarketSettingsProvider';
import styles from './Snowfall.module.scss';

const ReactSnowfall = dynamic(() => import('react-snowfall'), { ssr: false });

const MOBILE_BREAKPOINT = 768;
const SNOWFLAKE_COUNT_MOBILE = 50;
const SNOWFLAKE_COUNT_DESKTOP = 150;
const SPEED_MOBILE: [number, number] = [0.5, 2.0];
const SPEED_DESKTOP: [number, number] = [1.0, 3.0];

export const Snowfall = () => {
  const market = useMarket();
  const [snowflakeCount, setSnowflakeCount] = useState(SNOWFLAKE_COUNT_MOBILE);
  const [speed, setSpeed] = useState<[number, number]>(SPEED_MOBILE);

  useEffect(() => {
    const updateSettings = () => {
      const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
      setSnowflakeCount(isMobile ? SNOWFLAKE_COUNT_MOBILE : SNOWFLAKE_COUNT_DESKTOP);
      setSpeed(isMobile ? SPEED_MOBILE : SPEED_DESKTOP);
    };

    updateSettings();
    window.addEventListener('resize', updateSettings);
    return () => window.removeEventListener('resize', updateSettings);
  }, []);

  if (market !== 'wayke') {
    return null;
  }

  return (
    <div className={styles.snowfall} aria-hidden="true">
      <ReactSnowfall snowflakeCount={snowflakeCount} speed={speed} />
    </div>
  );
};
